import { createFileRoute } from '@tanstack/react-router';
import { CampaignSentDeliveryRouteView } from '@/pages/workspaces/automations/[campaignId]/sent/routing';

function CampaignSentDeliveryRoute() {
  const { campaignId, deliveryId } = Route.useParams();
  return <CampaignSentDeliveryRouteView campaignId={campaignId} deliveryId={deliveryId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/sent/$deliveryId',
)({
  component: CampaignSentDeliveryRoute,
});
